import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { FieldArray } from 'react-final-form-arrays';
import { useCallback } from 'react';

import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Button } from 'UIPackage/MainModule/components/Button';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getKnmFormRef } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { IKnmErknmFormPresenceDelegateFullName } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormPresenceDelegateFullName';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './ErknmOtherInfo.module.scss';

interface IErknmPresenceProps {
  watchOnly: boolean;
  isPresence: boolean | undefined;
}

interface IErknmPresenceStoreProps {
  formRef: IKnmFormRef | undefined;
}

const ErknmPresenceWithoutStore = ({
  watchOnly,
  isPresence,
  formRef,
}: IErknmPresenceProps & IErknmPresenceStoreProps) => {
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;

  const addField = useCallback(
    () => !watchOnly && push && push('isPresenceDelegateFullNames', { listId: uuidv4(), guid: uuidv4() }),
    [push, watchOnly],
  );

  const makeRemoveField = (index: number) => () => !watchOnly && remove && remove('isPresenceDelegateFullNames', index);

  return (
    <>
      <Row>
        <FieldBlock
          label="Отметка о присутствии контролируемого лица и (или) его представителя"
          button={
            isPresence && (
              <Button
                className="shared-btn-add"
                text="Добавить"
                type="button"
                variant="link"
                color="primary"
                disabled={watchOnly}
                onClick={addField}
              />
            )
          }
        >
          <SelectInputField
            className={styles.SelectField}
            id="isPresence"
            name="isPresence"
            options={booleanSelectOptions}
            size="medium"
            isClearable={false}
            disabled={watchOnly}
          />
        </FieldBlock>
      </Row>
      {isPresence && (
        <FieldArray name="isPresenceDelegateFullNames">
          {({ fields }) => {
            if (!fields.length) {
              return null;
            }

            return (
              <Row>
                {fields.map((fieldName, index) => {
                  const fieldValue: IKnmErknmFormPresenceDelegateFullName = fields.value?.[index];

                  return (
                    <Row key={fieldValue.listId} margin="medium" isListItem notWrap>
                      <FieldBlock>
                        <TextareaField name={`${fieldName}.value`} disabled={watchOnly} />
                      </FieldBlock>
                      <CloseButton className="shared-deleting-row-btn" onClick={makeRemoveField(index)} />
                    </Row>
                  );
                })}
              </Row>
            );
          }}
        </FieldArray>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState): IErknmPresenceStoreProps => ({
  formRef: getKnmFormRef(state),
});

export const ErknmPresence = connect(mapStateToProps)(ErknmPresenceWithoutStore);
